const orderSummary = require('./orderSummary');
const constants = require('../utils/constants');

const BOOKING_FORM_ELEMENT = document.getElementById('booking-form');
let NUMBER_OF_PASSENGERS = 1;
const validateBookingForm = (event) => {
    event.preventDefault();
    event.stopPropagation();

    let isValid = true;

    if (BOOKING_FORM_ELEMENT.checkValidity() === false) {
        const flightDateInput = document.getElementById('booking-form-flightDate');
        const flightHourInput = document.getElementById('booking-form-flightHour');
        const flightTypeInput = document.getElementById('booking-form-flightType');

        if (flightDateInput.value !== '') {
            flightDateInput.classList.remove('is-invalid');
            flightDateInput.classList.add('is-valid');
        } else {
            flightDateInput.classList.remove('is-valid');
            flightDateInput.classList.add('is-invalid');
            isValid = false;
        }

        if (flightHourInput.value !== '') {
            flightHourInput.classList.remove('is-invalid');
            flightHourInput.classList.add('is-valid');
        } else {
            flightHourInput.classList.remove('is-valid');
            flightHourInput.classList.add('is-invalid');
            isValid = false;
        }

        if (flightTypeInput.value !== '') {
            flightTypeInput.classList.remove('is-invalid');
            flightTypeInput.classList.add('is-valid');
        } else {
            flightTypeInput.classList.remove('is-valid');
            flightTypeInput.classList.add('is-invalid');
            isValid = false;
        }
    }

    const phoneInput = document.getElementById('booking-form-phone');
    const emailInput = document.getElementById('booking-form-email');

    if (phoneInput.value !== '') {
        const phoneRegex = /^\+[1-9](?:\s?\d){10,}$/;
        if (!phoneRegex.test(phoneInput.value.trim())) {
            phoneInput.classList.remove('is-valid');
            phoneInput.classList.add('is-invalid');
            isValid = false;
        } else {
            phoneInput.classList.remove('is-invalid');
            phoneInput.classList.add('is-valid');
        }
    } else {
        phoneInput.classList.remove('is-valid');
        phoneInput.classList.add('is-invalid');
        isValid = false;
    }

    if (emailInput.value !== '') {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(emailInput.value.trim())) {
            emailInput.classList.remove('is-valid');
            emailInput.classList.add('is-invalid');
            isValid = false;
        } else {
            emailInput.classList.remove('is-invalid');
            emailInput.classList.add('is-valid');
        }
    }

    BOOKING_FORM_ELEMENT.classList.add('was-validated');

    if (isValid && BOOKING_FORM_ELEMENT.checkValidity() === true) {
        event.target.submit();
    } else {
        BOOKING_FORM_ELEMENT.scrollIntoView();
    }
}

const createAddPassengerButton = () => {
    const maximumPassengers = parseInt(document.getElementById('maximum-passengers').dataset.maximumPassengers);
    let freeCapacity = constants.existingReservation
        ? constants.reservation.flightData.freeCapacity - constants.reservation.flightData.toConfirmPassengers
        : JSON.parse(document.getElementById('booking-form-flightData').value).freeCapacity - JSON.parse(document.getElementById('booking-form-flightData').value).toConfirmPassengers;
    NUMBER_OF_PASSENGERS = constants.existingReservation ? constants.reservation.numberOfPassengers : parseInt(document.getElementById('booking-form-numberOfPassengers').value);

    if (freeCapacity >= NUMBER_OF_PASSENGERS + 1 && !document.querySelector('.add-passenger')) {
        const passengerButton = document.createElement('div');
        passengerButton.classList.add('add-passenger');

        const passengerFieldset = BOOKING_FORM_ELEMENT.querySelector('#booking-form-passengersInformation');
        passengerFieldset.appendChild(passengerButton);

        const numberOfPassengersInput = document.getElementById('booking-form-numberOfPassengers');

        passengerButton.addEventListener('click', () => {
            freeCapacity = JSON.parse(document.getElementById('booking-form-flightData').value).freeCapacity - JSON.parse(document.getElementById('booking-form-flightData').value).toConfirmPassengers;

            NUMBER_OF_PASSENGERS = parseInt(document.getElementById('booking-form-numberOfPassengers').value);
            NUMBER_OF_PASSENGERS += 1;
            numberOfPassengersInput.value = NUMBER_OF_PASSENGERS;

            document.getElementById('number-of-passengers-value').innerHTML = NUMBER_OF_PASSENGERS;
            updatePassengersInformationsField(NUMBER_OF_PASSENGERS * 3, 'addPassengerButton');
            orderSummary.updateOrderSummaryTable();

            if (NUMBER_OF_PASSENGERS >= freeCapacity || NUMBER_OF_PASSENGERS >= maximumPassengers) {
                passengerButton.remove();
            }

            const calendar = require('./calendar');
            calendar.updateQuickReleaseData();
        });
    }
}

const removeAddPassengerButton = () => {
    const addPassengerButton = document.querySelector('.add-passenger');
    if (addPassengerButton) {
        addPassengerButton.remove();
    }
}

const updatePassengersInformationsField = (nbItemsToShow, clickedPassengerId) => {
    const passengersInformationFieldset = BOOKING_FORM_ELEMENT.querySelector('#booking-form-passengersInformation');
    const passengersInformation = [];

    if (constants.existingReservation && clickedPassengerId === undefined) {
        JSON.parse(constants.reservation.passengersInformation).forEach((passenger, index) => {
            const passengerNumber = index + 1;
            const passengerNameInput = passengersInformationFieldset.querySelector(`#booking-form-passenger${passengerNumber}Name`);
            const passengerWeightInput = passengersInformationFieldset.querySelector(`#booking-form-passenger${passengerNumber}Weight`);
            const passengerIsChildInput = passengersInformationFieldset.querySelector(`#booking-form-passenger${passengerNumber}IsChild`);

            passengerNameInput.value = passenger.name;
            passengerWeightInput.value = passenger.weight;
            passenger.isChild === '1' ? passengerIsChildInput.checked = true : passengerIsChildInput.checked = false;
        });
    } else if (clickedPassengerId) {
        let count = 0;
        let passengerId = 0;
        let passengerData = [];

        // store passengers information into an array
        passengersInformationFieldset.querySelectorAll('.clearfix').forEach((formElement) => {
            if (!formElement.classList.contains('hidden')) {
                switch (count % 3) {
                    case 0:
                        passengerData = [];
                        passengerId++;
                        passengerData['name'] = formElement.querySelector('.form-control').value;
                        break;
                    case 1:
                        passengerData['weight'] = formElement.querySelector('.form-control').value;
                        break;
                    case 2:
                        passengerData['isChild'] = !!formElement.querySelector('.form-check-input').checked;
                        break;
                }
            } else {
                return false;
            }
            if (count !== 0 && count % 3 === 2 && passengerId !== clickedPassengerId) {
                passengersInformation.push(passengerData);
            }
            count++;
        });
    }

    // hide all passengers fields and remove values
    passengersInformationFieldset.querySelectorAll('.clearfix').forEach((formElement) => {
        formElement.classList.add('hidden');
        const formControl = formElement.querySelector('.form-control');
        if (formControl) {
            formControl.removeAttribute('required');
            formControl.value = '';
        } else if (formElement.querySelector('.form-check-input')) {
            formElement.querySelector('.form-check-input').checked = false;
        }
    });

    // show passengers fields regarding the number of passengers
    let count = 0;
    passengersInformationFieldset.querySelectorAll('.clearfix').forEach((formElement) => {
        if (count < nbItemsToShow) {
            formElement.classList.remove('hidden');

            if (formElement.classList.contains('is-child-checkbox') && count <= nbItemsToShow && nbItemsToShow > 3) {
                // show remove passenger button after is child checkbox
                addRemovePassengerButton(formElement, Math.floor(count / 3) + 1);
            } else if (formElement.classList.contains('is-child-checkbox') && formElement.classList.contains('show-remove-passenger')) {
                formElement.classList.remove('show-remove-passenger');
                formElement.querySelector('.remove-passenger').remove();
            }

            // set form control as required
            var formControl = formElement.querySelector('.form-control');
            if (formControl) {
                formControl.setAttribute('required', 'true');
            }

            const passengerId = Math.floor(count / 3);
            // set form control value
            if (Object.keys(passengersInformation).length && passengersInformation[passengerId]) {
                switch (count % 3) {
                    case 0:
                        formElement.querySelector('.form-control').value = passengersInformation[passengerId].name;
                        break;
                    case 1:
                        formElement.querySelector('.form-control').value = passengersInformation[passengerId].weight;
                        break;
                    case 2:
                        formElement.querySelector('.form-check-input').checked = passengersInformation[passengerId].isChild;
                        break;
                }
            }
        } else {
            return false;
        }
        count++;
    });
}

const addRemovePassengerButton = (formElement, passengerId) => {
    if (formElement.querySelector('.remove-passenger') === null) {
        const removePassengerButton = document.createElement('div');
        removePassengerButton.classList.add('remove-passenger');

        formElement.appendChild(removePassengerButton);
        formElement.classList.add('show-remove-passenger');

        removePassengerButton.addEventListener('click', () => {
            NUMBER_OF_PASSENGERS -= 1;
            document.getElementById('booking-form-numberOfPassengers').value = NUMBER_OF_PASSENGERS;
            document.getElementById('number-of-passengers-value').innerHTML = NUMBER_OF_PASSENGERS;
            updatePassengersInformationsField(NUMBER_OF_PASSENGERS * 3, passengerId);
            orderSummary.updateOrderSummaryTable();
            if (!document.querySelector('.add-passenger')) {
                createAddPassengerButton();
            }

            const calendar = require('./calendar');
            calendar.updateQuickReleaseData();
            calendar.updateCalendar();
        });
    }
}

const fillSubscriberInformation = () => {
    document.getElementById('booking-form-title').value = constants.reservation.subscriber.title;
    document.getElementById('booking-form-firstName').value = constants.reservation.subscriber.firstName;
    document.getElementById('booking-form-lastName').value = constants.reservation.subscriber.lastName;
    document.getElementById('booking-form-address').value = constants.reservation.subscriber.address;
    document.getElementById('booking-form-postalCode').value = constants.reservation.subscriber.postalCode;
    document.getElementById('booking-form-city').value = constants.reservation.subscriber.city;
    document.getElementById('booking-form-phone').value = constants.reservation.subscriber.phone;
    document.getElementById('booking-form-email').value = constants.reservation.subscriber.email;

    document.getElementById('booking-form-numberOfPassengers').value = constants.reservation.numberOfPassengers;
}

module.exports = {
    validateBookingForm,
    updatePassengersInformationsField,
    createAddPassengerButton,
    removeAddPassengerButton,
    fillSubscriberInformation
}
